import { heroMain, heatBoard } from "@/mocks/leakData";

export default function Hero() {
  const top = heatBoard[0];
  return (
    <section id="headline" className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
        {/* 版头条 */}
        <div className="flex flex-col gap-8 lg:flex-row">
          {/* 左：大主视觉压顶 */}
          <article className="relative flex-1 overflow-hidden rounded-xl">
            <div className="relative aspect-[16/9] w-full overflow-hidden rounded-xl">
              <img
                src={heroMain.cover}
                alt="百亿并购对赌条款泄露 抢先版内幕头条"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/10" />
              <div className="absolute right-3 top-3 flex items-center gap-2 md:right-5 md:top-5">
                <span className="rounded-sm bg-primary-500 px-2 py-1 text-[11px] font-bold tracking-wide text-background-50">
                  {heroMain.meta}
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                <span className="mb-3 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-accent-400">
                  <i className="ri-flashlight-fill" />
                  {heroMain.kicker}
                </span>
                <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                  {heroMain.title}
                </h1>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-base">
                  {heroMain.subtitle}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-background-100/70">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-fire-fill text-accent-400" />
                    全网热度 {heroMain.heat}
                  </span>
                  <span className="hidden h-3 w-px bg-background-100/20 sm:block" />
                  <span>{heroMain.reads}</span>
                  <a
                    href="#express"
                    className="inline-flex items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-950 transition hover:bg-accent-300 sm:ml-auto"
                  >
                    进入抢先速递
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </div>
          </article>

          {/* 右：今日第一手 速览堆叠 */}
          <aside className="flex w-full flex-col gap-4 lg:w-[340px]">
            <div className="flex items-center justify-between px-1">
              <h2 className="font-heading text-base font-bold text-background-50">
                今日第一手 <span className="text-accent-400">Top 热度</span>
              </h2>
              <a href="#heat" className="text-xs text-background-100/60 transition hover:text-accent-300">
                查看榜单
              </a>
            </div>

            <a href="#heat" className="group relative overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=mysterious%20businessman%20silhouette%20reviewing%20secret%20contract%20documents%20in%20dark%20office%2C%20dramatic%20crimson%20and%20amber%20light%2C%20cinematic%20investigative%20editorial%20photojournalism&width=680&height=520&seq=side-deal-01&orientation=landscape"
                alt="内部信源提供的一手并购对赌条款原稿 第一手内幕"
                className="h-28 w-full object-cover object-top transition duration-500 group-hover:scale-105 md:h-32"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-3">
                <span className="mb-1 inline-block rounded-sm bg-accent-500/90 px-1.5 py-0.5 text-[10px] font-bold text-foreground-950">
                  线人一手文件
                </span>
                <p className="line-clamp-2 text-xs leading-snug text-background-50">
                  {top.title}
                </p>
              </div>
            </a>

            <div className="grid grid-cols-3 gap-3">
              {[
                { k: "今日独家", v: "23 篇" },
                { k: "已核验", v: "17 条" },
                { k: "待跟进", v: "9 条" },
              ].map((s) => (
                <div
                  key={s.k}
                  className="rounded-lg border border-background-100/15 bg-background-50/5 px-3 py-3 text-center"
                >
                  <p className="font-heading text-lg font-black text-accent-400">{s.v}</p>
                  <p className="mt-0.5 text-[11px] text-background-100/70">{s.k}</p>
                </div>
              ))}
            </div>

            <div className="mt-auto rounded-lg bg-background-50/5 p-4 ring-1 ring-background-100/15">
              <div className="flex items-start gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-600/20 text-primary-400">
                  <i className="ri-shield-keyhole-line text-lg" />
                </span>
                <p className="text-xs leading-relaxed text-background-100/80">
                  所有线索均经<strong className="text-accent-300">双重独立信源</strong>
                  交叉核验后发布，涉及隐去身份与敏感路径。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}